
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/glew-alternative",
      function () {
        return require("private-next-pages/glew-alternative.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/glew-alternative"])
      });
    }
  